import { ApolloProvider } from '@apollo/client';
import { theme } from '@cropink/ui-components';
import { ThemeProvider, Preflight } from '@xstyled/styled-components';
import { FC } from 'react';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { CornerDialogProvider } from '@contexts/CornerDialogContext';
import { client } from '@gql/client';
import { router } from '@root/src/routes/router';

export const RootProvider: FC = () => (
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
        <Preflight />
        <CornerDialogProvider>
          <RouterProvider router={router} />
        </CornerDialogProvider>
        <ToastContainer limit={1} />
      </DndProvider>
    </ThemeProvider>
  </ApolloProvider>
);
